import { render, staticRenderFns } from "./GooglePlayUpdateReviewStatus.vue?vue&type=template&id=06a7481e&scoped=true"
import script from "./GooglePlayUpdateReviewStatus.vue?vue&type=script&lang=js"
export * from "./GooglePlayUpdateReviewStatus.vue?vue&type=script&lang=js"
import style0 from "./GooglePlayUpdateReviewStatus.vue?vue&type=style&index=0&id=06a7481e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7481e",
  null
  
)

export default component.exports